import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ApiErrorResponse } from 'src/app/common/network';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { EligibilityRuleFormMode, EligibilityRule } from 'src/app/modules/PulseLeads/types/eligibility-rule-types';
import { fetchEligibilityRuleItem } from 'src/app/modules/PulseLeads/network/eligibilityRuleCrud';
import EligibilityRuleForm from './components/EligibilityRuleForm';
import { LeadGoalItem } from '../../ActivityPoint/lead-goal/list/lead-goal-listing-page.hook';
import { fetchLeadGoalList } from 'src/app/modules/PulseLeads/network/lead-goal-crud';

const EligibilityRuleDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? EligibilityRuleFormMode.EDIT : EligibilityRuleFormMode.CREATE,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [eligibilityRule, setEligibilityRule] = useState<EligibilityRule>();
  const [leadGoal, setLeadGoal] = useState<LeadGoalItem[]>();

  const reloadData = () => {
    fetchLeadGoalList({ active: true }).then((result) => {
      setLeadGoal(result.docs);
    });
    if (id) {
      setIsLoading(true);
      fetchEligibilityRuleItem(id, dispatch)
        .then((result) => {
          setEligibilityRule(result);
        })
        .catch((err: ApiErrorResponse) => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {formMode === EligibilityRuleFormMode.CREATE && <EligibilityRuleForm formMode={formMode} leadGoal={leadGoal} />}
      {formMode === EligibilityRuleFormMode.EDIT &&
        (isLoading || !eligibilityRule ? (
          <LayoutSplashScreen />
        ) : (
          <EligibilityRuleForm formMode={formMode} eligibilityRule={eligibilityRule} leadGoal={leadGoal} />
        ))}
    </>
  );
};

export default EligibilityRuleDetailPage;
